import { Navigate, useLocation } from 'react-router-dom';

/** /dashboard was a separate analytics page; it is now part of the Dashboard at / (spec §3.2). */
export default function DashboardPage() {
  const location = useLocation();
  return <Navigate to={{ pathname: '/', search: location.search }} state={location.state} replace />;
}
